import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="docs-toggle"
export default class extends Controller {
  docLink(evt) {
    const linkId = evt.target.dataset.docLinkId;
    window.dispatchEvent(new CustomEvent('doclink', {
      detail: { link: linkId, smooth: false }
    }));
  }
}
